import React, { useState } from 'react';
import { MapPin, Phone, Clock, ExternalLink } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { contactInfo } from '../data/mock';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { useToast } from '../hooks/use-toast';

const Contact = () => {
  const { language, t } = useLanguage();
  const { toast } = useToast();
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    message: ''
  });

  const handleSubmit = (e) => {
    // e.preventDefault();
    // // Store in localStorage for demo
    // const messages = JSON.parse(localStorage.getItem('contactMessages') || '[]');
    // messages.push({
    //   ...formData,
    //   timestamp: new Date().toISOString()
    // });
    // localStorage.setItem('contactMessages', JSON.stringify(messages));
    
    // toast({
    //   title: language === 'ro' ? 'Mesaj trimis!' : 'Message sent!',
    //   description: language === 'ro' 
    //     ? 'Vă mulțumim pentru mesaj. Vă vom răspunde în curând.'
    //     : 'Thank you for your message. We will respond soon.'
    // });
    
    // setFormData({ name: '', email: '', message: '' });

    e.preventDefault();

    // Subiect în funcție de limbă
    const subject =
      language === 'ro'
        ? 'Mesaj de pe site Saloon & Beer'
        : 'Message from Saloon & Beer website';

  // Corpul emailului
  const body = `
    ${language === 'ro' ? 'Nume' : 'Name'}: ${formData.name}
    ${language === 'ro' ? 'Telefon' : 'Phone'}: ${formData.phone}

    ${language === 'ro' ? 'Mesaj' : 'Message'}:
    ${formData.message}
    `;

    // Adresa la care vrei să primești mesajele
    const to = contactInfo.email || 'contact@saloonbeer.md';

    const mailtoLink = `mailto:${to}?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;

    // Deschide clientul de email
    window.location.href = mailtoLink;

    // Toast de confirmare (opțional)
    toast({
      title: language === 'ro' ? 'Deschidem clientul de email' : 'Opening email client',
      description:
        language === 'ro'
          ? 'Mesajul este pregătit în aplicația ta de email.'
          : 'Your message is ready in your email app.'
    });

    // Golește câmpurile din formular
    setFormData({ name: '', phone: '', message: '' });
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <section id="contact" className="py-20" style={{ backgroundColor: 'white' }}>
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="mb-3">{t.contact.title}</h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Contact Info */}
          <div className="space-y-6">
            <Card className="p-6">
              <div className="flex items-start gap-4">
                <div className="p-3 rounded-lg" style={{ backgroundColor: 'var(--beige-warm)' }}>
                  <MapPin size={24} style={{ color: 'var(--brown-dark)' }} />
                </div>
                <div>
                  <h3 className="font-semibold mb-2" style={{ color: 'var(--brown-dark)' }}>
                    {t.contact.address}
                  </h3>
                  <p style={{ color: 'var(--brown-medium)' }}>
                    {language === 'ro' ? contactInfo.address : contactInfo.addressEn}
                  </p>
                  {/* <p className="text-sm mt-1" style={{ color: 'var(--brown-medium)' }}>
                    {contactInfo.plusCode}
                  </p> */}
                  <a
                    href={contactInfo.plusCodeUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-lg font-medium hover:opacity-70 transition-opacity"
                    style={{ color: 'var(--amber)' }}
                  >
                    {contactInfo.plusCode}
                  </a>
                </div>
              </div>
            </Card>

            <Card className="p-6">
              <div className="flex items-start gap-4">
                <div className="p-3 rounded-lg" style={{ backgroundColor: 'var(--beige-warm)' }}>
                  <Phone size={24} style={{ color: 'var(--brown-dark)' }} />
                </div>
                <div>
                  <h3 className="font-semibold mb-2" style={{ color: 'var(--brown-dark)' }}>
                    {t.contact.phone}
                  </h3>
                  <a
                    href="tel:+37378015880"
                    className="text-lg font-medium hover:opacity-70 transition-opacity"
                    style={{ color: 'var(--amber)' }}
                  >
                    {contactInfo.phone}
                  </a>
                </div>
              </div>
            </Card>

            <Card className="p-6">
              <div className="flex items-start gap-4">
                <div className="p-3 rounded-lg" style={{ backgroundColor: 'var(--beige-warm)' }}>
                  <Clock size={24} style={{ color: 'var(--brown-dark)' }} />
                </div>
                <div>
                  <h3 className="font-semibold mb-2" style={{ color: 'var(--brown-dark)' }}>
                    {t.contact.hours}
                  </h3>
                  <p style={{ color: 'var(--brown-medium)' }}>
                    {t.contact.hoursDetails}
                  </p>
                </div>
              </div>
            </Card>

            <div className="flex flex-col sm:flex-row gap-3">
              <Button
                asChild
                className="btn-primary flex-1"
              >
                <a
                  href={contactInfo.mapUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center gap-2"
                >
                  <ExternalLink size={18} />
                  {t.contact.getDirections}
                </a>
              </Button>
            </div>
          </div>
          
          {/* Contact Form */}
          <Card className="p-8">
            <h3 className="text-2xl font-semibold mb-6" style={{ color: 'var(--brown-dark)' }}>
              {t.contact.formTitle}
            </h3>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label className="block text-sm font-medium mb-2" style={{ color: 'var(--brown-dark)' }}>
                  {t.contact.name}
                </label>
                <Input
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-2" style={{ color: 'var(--brown-dark)' }}>
                  {t.contact.email}
                </label>
                <Input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  //onChange={handleChange}
                  onChange={(e) => {
                    const value = e.target.value;

                    // allow only "+" at first position and digits afterwards
                    if (/^\+?[0-9]*$/.test(value)) {
                    setFormData({ ...formData, phone: value });
                    }
                  }}
                  required
                  pattern="^\+?[0-9]{6,15}$"
                  className="w-full"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-2" style={{ color: 'var(--brown-dark)' }}>
                  {t.contact.message}
                </label>
                <Textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows={5}
                  className="w-full"
                />
              </div>
              <Button type="submit" className="btn-primary w-full">
                {t.contact.send}
              </Button>
            </form>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default Contact;